import * as HERRAMIENTAS from './herramientas/constantes';
/* actions */

import { loadConfig, addPantalla, pantalla, zona, notas, ejecutarFuncion, seleccionarHerramienta, ocultarReloj, mostrarReloj, moverReloj, crearSesion, activarSesion // TODO: podria no exportarse esto encapsulando las funcionalidades de textos de usuario ?
} from './actions';
import { crearTexto, actualizarTexto } from './texto-usuario/actions';
/* selectors */

import { getPantallaProps, getImagenUsuarioVisible, getTextosUsuarioVisible, getConfigIndice, getConfigLibros, getConfigCaminos, getConfigGeneral, getConfigPortada } from './selectors';
import { getIdByNum, getNumPaginaIzquierda, getDimensionesBaja, getMultiplicadorBaja, getPrimeraPagina, getUltimaPagina, getConsolaLupaDefecto, getBajaToAltaX, getBajaToAltaY } from './selectors/config-libro';
import { getConfigBotones } from './selectors/config-botones';
import { getZonas, getZona, getCaminoPagina } from './selectors/config-paginas';
import { getConfigVentanas } from './selectors/config-ventanas';
import * as selectorsZona from './selectors/zona';
import * as selectorsPizarra from './pizarra/selectors';
import * as selectorsTextosUsuario from './texto-usuario/selectors';
import * as selectorsReloj from './selectors/reloj';
import * as selectorsBarraHerramientas from './selectors/barra-herramientas'; // import * as selectorsSesiones from './gestor-sesiones/selectors'

/* pantallas y componentes */

import * as TextosUsuario from './texto-usuario';
import * as PantallaLibro from './pantalla-libro';
import * as PantallaIndice from './pantalla-indice';
import PantallaVentana from './pantalla-ventana';
import * as Util from './util';
import * as Flashcards from './flashcards';
/** Public Constantes */

export { PRIMERA_VENTANA_ID, SEGUNDA_VENTANA_ID, PANTALLA_ANTERIOR_ID, PANTALLA_LIBRO_ID, PANTALLA_PORTADA_ID, PANTALLA_INDICE_ID, PANTALLA_VENTANA_ID } from './constantes';
export { HERRAMIENTAS };
/** Storage */

export { setKeyStorageRoot, setTitleRoot } from './util';
export { default as configureStore } from './store';
/** Actions */

export var actions = {
  loadConfig: loadConfig,
  addPantalla: addPantalla,
  pantalla: pantalla,
  zona: zona,
  notas: notas,
  ejecutarFuncion: ejecutarFuncion,
  seleccionarHerramienta: seleccionarHerramienta,
  crearTexto: crearTexto,
  actualizarTexto: actualizarTexto,
  mostrarReloj: mostrarReloj,
  ocultarReloj: ocultarReloj,
  moverReloj: moverReloj,
  crearSesion: crearSesion,
  activarSesion: activarSesion
  /** Selectors */

};
export var selectors = {
  getPantallaProps: getPantallaProps,
  getImagenUsuarioVisible: getImagenUsuarioVisible,
  getTextosUsuarioVisible: getTextosUsuarioVisible,
  getConfigIndice: getConfigIndice,
  getConfigLibros: getConfigLibros,
  getConfigCaminos: getConfigCaminos,
  getConfigGeneral: getConfigGeneral,
  getConfigPortada: getConfigPortada,
  // config-libro
  getIdByNum: getIdByNum,
  getNumPaginaIzquierda: getNumPaginaIzquierda,
  getDimensionesBaja: getDimensionesBaja,
  getMultiplicadorBaja: getMultiplicadorBaja,
  getPrimeraPagina: getPrimeraPagina,
  getUltimaPagina: getUltimaPagina,
  getConsolaLupaDefecto: getConsolaLupaDefecto,
  getBajaToAltaX: getBajaToAltaX,
  getBajaToAltaY: getBajaToAltaY,
  // config-botones
  getConfigBotones: getConfigBotones,
  // config-paginas
  getZonas: getZonas,
  getZona: getZona,
  getCaminoPagina: getCaminoPagina,
  // config-ventanas
  getConfigVentanas: getConfigVentanas
};
export { selectorsZona };
export { selectorsPizarra };
export { selectorsTextosUsuario };
export { selectorsBarraHerramientas };
export { selectorsReloj }; // export { selectorsSesiones }

/** Componentes  */

export { default as Ibook } from './ibook';
export { default as Precarga } from './precarga';
export { default as Paginacion } from './paginacion';
export { default as CajaLateral } from './caja-lateral';
export { default as ConsolaLupa } from './consola-lupa/consola-lupa';
export { default as ConsolaAudio } from './consola-audio/consola-audio';
export { default as Texto } from './texto/texto';
export { default as MarcoAmpliacion } from './marco-ampliacion/marco-ampliacion';
export { default as Pagina } from './pagina';
export { default as Pizarra } from './pizarra/pizarra';
export { TextosUsuario };
export { default as VentanaSimple } from './ventana-simple';
export { default as Botonera } from './ventana-simple/botonera';
export { default as VentanaImpresion } from './ventana-impresion';
export { default as ContenidoVentana } from './contenido-ventana';
export { Boton, BotonImagen } from './botones';
export { default as Crono } from './crono';
export { default as GestorSesionesContainer } from './gestor-sesiones';
/** pantallas */

export { PantallaIndice };
export { PantallaVentana };
export { PantallaLibro };
/** Containers */

export { default as BotonHerramientasContainer } from './boton-herramientas/boton-herramientas-container';
export { default as BarraHerramientasContainer } from './barra-herramientas/barra-herramientas-container';
export { CronoContainer } from './crono';
export { default as MascarasContainer } from './mascaras';
export { default as CartulinaContainer } from './cartulina';
export { default as PersianaContainer } from './persiana';
/** Util */

export { Util };
/** flashcards */

export { Flashcards };